export const DATA_COMPONENT_ATTRIBUTE = 'data-component';

/**
 * Merges a component's own name with any `data-component` value it inherited from a
 * composed parent, producing a deduped, space-separated token list (e.g.
 * `"DatePicker InputGroup"`). When one component is rendered as another's root — via a
 * Base UI `render` prop or direct composition — this preserves both identities instead
 * of the inner name clobbering the outer one. With no inherited value it returns just
 * `name`, a single token identical to a standalone component. Consumers should match it
 * with the `~=` attribute selector rather than exact `=`.
 */
export function mergeDataComponent(
  inherited: string | undefined,
  name: string
): string {
  if (!inherited) return name;
  const tokens = [...new Set(inherited.split(' ').filter(Boolean))];
  if (!tokens.includes(name)) tokens.push(name);
  return tokens.join(' ');
}
